(function() {
    'use strict';
    angular.module('elogbooks.admin.pricing-schedules', []);
})();
